import { defineStore } from 'pinia'
import { useOrderStore } from '@/stores/order'
import { useStripeStore } from '@/stores/stripe'
import api from '@/services/api/payments'
import { getError } from '@/utils/errors'

export const usePaymentStore = defineStore('payment', () => {
  const PaymentIntentSuccessStatuses = {
    SUCCEEDED: 'succeeded',
    REQUIRES_CAPTURE: 'requires_capture'
  }

  async function requestPaymentIntentForCof(
    cardId: string
  ): Promise<{ paymentIntentId: string; customerEmail: string; error?: string }> {
    const orderStore = useOrderStore()
    const stripeStore = useStripeStore()
    const orderData = {
      items: orderStore.items
    }
    const genericError = 'Unable to complete the payment.'
    const paymentIntentResponse = await api.getPaymentIntentSecretForCof(cardId, orderData)

    if (!paymentIntentResponse.error) {
      const { error, paymentIntent } = await stripeStore.stripe.confirmPayment({
        clientSecret: paymentIntentResponse.client_secret,
        redirect: 'if_required'
      })

      if (
        paymentIntent?.status === PaymentIntentSuccessStatuses.SUCCEEDED ||
        paymentIntent?.status === PaymentIntentSuccessStatuses.REQUIRES_CAPTURE
      ) {
        return {
          paymentIntentId: paymentIntent.id,
          customerEmail: paymentIntentResponse.customer_email
        }
      } else {
        return { error: error?.message || genericError, paymentIntentId: '', customerEmail: '' }
      }
    } else {
      return {
        error: getError(paymentIntentResponse),
        paymentIntentId: '',
        customerEmail: ''
      }
    }
  }

  return {
    requestPaymentIntentForCof
  }
})
